import React, {useState,useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import stylesDash from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import '../Operative/Operative.css';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import SweetAlert2 from 'react-sweetalert2';

//happ-components
import SelectOperative from 'happ-components/Operatives/SelectOperative'; 
import InputDni from 'happ-components/Operatives/InputDni';
import HealthBenefits from 'happ-components/Operatives/HealthBenefits';


//happ-icons and happ-spinners
import { IconIM } from "happ-components/happ-icons/icons";
import { SpinnerLoading } from "happ-components/happ-spinners/spinners";

import {getInitOperatives, saveHealthBenefitResults, setCreateStatus} from 'happ-redux/happ-actions/operative/operativeActions';
import useValidatorforms from "happ-custom-hooks/useValidatorforms";


const stylesPanel = {
    cardTitle,
    pageSubcategoriesTitle: {
      color: "#3C4858",
      textDecoration: "none",
      textAlign: "center",
    },
    cardCategory: {
      margin: "0",
      color: "#999999",
    },
  };
const ProfileStyle = makeStyles(styles);  
const useStyles = makeStyles(stylesPanel);
const dashStyles = makeStyles(stylesDash);

let samplingInitState = {
    operative: '',
    dni: '',
    ayunas: false,
    glicemia: '',
    peso: '',
    altura: '',
    deportista: false,
    colesterol: '',
    trigliceridos: '',
    sistolica_bi: '',
    diastolica_bi: '',
    circunferencia: '',
    comentarios: '',
  };

const Sampling = () => {
    const classes = useStyles();
    const ProfileClass = ProfileStyle();
    const DashClass = dashStyles();
    const [swalProps, setSwalProps] = useState({
        show: true,
        text: 'Muestras registradas con exito',
        type: 'success',
        icon: 'success',
    });
    const [swalPropsError, setSwalPropsError] = useState({
        show: true,
        text: 'Colaborador no existe, no puede registrarse ninguna muestra',
        type: 'success',
        icon: 'error' 
    });

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getInitOperatives());
    }, []);
    const msg_error_currents_results = useSelector(state => state.operative.msg_error_currents_results);
    const operativesArray = useSelector(state => state.operative.operatives);
    const currentOperativeSampling = useSelector(state => state.operative.currentOperativeSampling);
    const patient = useSelector(state => state.operative.patient);
    const create_status = useSelector(state => state.operative.create_status);
    const disabled = useSelector(state => state.operative.disabled);
    const okInputs = useSelector(state => state.operative.okInputs);
    const {
        state,
        errors,
        handlerSubmit,
        handlerChange,
        handlerChangeDni,
        handlerChangeOperativeSampling
    } = useValidatorforms(samplingInitState, sendSampling);

    
    function sendSampling(){
        dispatch(saveHealthBenefitResults(patient, state));
        state.dni = '';
        state.ayunas = false;
        state.glicemia = '';
        state.peso = '';
        state.altura = '';
        state.colesterol = '';
        state.trigliceridos = '';
        state.sistolica_bi = '';
        state.diastolica_bi = '';
        state.circunferencia = '';
        state.comentarios = '';
    }  
    return ( 
        <GridContainer className="global-container">
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardHeader color="rose" icon>
                        <CardIcon className={`${ProfileClass.iconBack} content-icons`}>
                            <IconIM />
                        </CardIcon>
                    </CardHeader>
                    <CardBody>
                        {create_status ? (
                            <SweetAlert2 {...swalProps} 
                            />
                        ) : null}
                        <form
                            onSubmit={handlerSubmit}
                            className='form-operative'
                        >
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                    <SelectOperative 
                                        classes={ProfileClass}
                                        operatives={operativesArray}
                                        handlerChangeOperative={handlerChangeOperativeSampling}
                                        state={state}
                                    />
                                </GridItem>
                                {msg_error_currents_results ? (
                                     <SweetAlert2 {...swalPropsError} 
                                        didClose={() => {
                                            window.location.href = '/';
                                        }}
                                     />
                                ) : null}
                                {currentOperativeSampling ? (
                                    <>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <InputDni 
                                                classes={ProfileClass}
                                                handlerChange={handlerChange}
                                                handlerChangeDni={handlerChangeDni}
                                                state={state}
                                                errors={errors}
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12} className={`show-section-${okInputs}`}>
                                            <HealthBenefits 
                                                currentOperative={currentOperativeSampling}
                                                handlerChange={handlerChange}
                                                state={state}
                                                errors={errors}
                                                onlyPoll={false}
                                                title='Toma de muestra'
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12} className={`show-section-${okInputs} btn-center`}>
                                            <Button
                                                className={`${classes.backButton} happ-background-color color-white`}
                                                type="submit"
                                                disabled={disabled}
                                            >
                                                Guardar
                                            </Button>
                                        </GridItem>                                            
                                    </>
                                ) : null}
                            </GridContainer>
                        </form>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>                    
    );
}
 
export default Sampling;